import { apiUrl } from "../../lib/api";
import { hierarchyDestination } from "../../hierarchy/urls";

/** AuthKit entry. Optional slug lands the owner in that workspace after login. */
export function authKitLoginUrl(slug?: string, destination?: string): string {
  const next = hierarchyDestination(destination)?.path ?? (slug
    ? `/login?welcome=1&slug=${encodeURIComponent(slug)}`
    : "/login?welcome=1");
  return apiUrl(`/auth/login?next=${encodeURIComponent(next)}`);
}
